import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import Header from '../components/Header';
import NavBar from '../components/NavBar';

export const PrivateRoute = ({
  isAuthenticated,
  activeClass,
  component: Component,
  ...rest
}) => (
  <Route
    {...rest}
    component={(props) =>
      isAuthenticated ? (
        <div>
          <Header />
          <NavBar activeClass={activeClass} />
          <Component {...props} item={activeClass} />
        </div>
      ) : (
        <Redirect to='/' />
      )
    }
  />
);

const mapStateToProps = (state) => ({
  isAuthenticated: !!state.auth.uid,
});

export default connect(mapStateToProps)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/routers/PrivateRoute.js